import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
  statementAccounts: [],
  newStatementAccountPreferences: [],
};

export const deliveryPreferencesSlice = createSlice({
  name: 'deliveryPreferencesSlice',
  initialState,
  reducers: {
    resetState: () => {
      return { ...initialState };
    },
    setLoading: (state, action) => {
      return { ...state, isLoading: action.payload };
    },
    setStatementAccounts: (state, action) => {
      return { ...state, statementAccounts: action.payload };
    },
  },
});

export const { resetState, setLoading, setStatementAccounts } = deliveryPreferencesSlice.actions;
export default deliveryPreferencesSlice.reducer;
